import {
    startRegistration,
    startAuthentication,
    browserSupportsWebAuthn,
    platformAuthenticatorIsAvailable,
} from "@simplewebauthn/browser";
import { api } from "./api";

export function passkeySupported() {
    try {
        return browserSupportsWebAuthn();
    } catch {
        return false;
    }
}

export async function platformPasskeyAvailable() {
    try {
        return await platformAuthenticatorIsAvailable();
    } catch {
        return false;
    }
}

// Enroll a new passkey for the currently-authenticated user.
export async function enrollPasskey(label = "") {
    const { data: optionsJSON } = await api.post("/auth/webauthn/register/generate");
    const credential = await startRegistration({ optionsJSON });
    const { data } = await api.post("/auth/webauthn/register/verify", {
        credential,
        label,
    });
    return data.passkey;
}

// Authenticate with a passkey. `email` is optional — when omitted the browser
// shows any discoverable passkeys for this site (one-tap login).
export async function authenticateWithPasskey(email = "") {
    const { data: gen } = await api.post("/auth/webauthn/login/generate", { email });
    const credential = await startAuthentication({ optionsJSON: gen.options });
    const { data } = await api.post("/auth/webauthn/login/verify", {
        challenge_id: gen.challenge_id,
        credential,
    });
    return data; // { user, token }
}

export async function listPasskeys() {
    const { data } = await api.get("/auth/webauthn/credentials");
    return data.passkeys || [];
}

export async function deletePasskey(id) {
    await api.delete(`/auth/webauthn/credentials/${id}`);
}
